"use client";

import { Book, FileText, Globe, Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const courses = [{
  id: 1,
  title: "IELTS Preparation",
  description: "Our IELTS Academic equip students with the\nstrategies and skills required to achieve\ncompetitive scores.",
  icon: FileText,
  path: "/CoursesPage#ielts"
}, {
  id: 2,
  title: "TOEFL Preparation",
  description: "Our TOEFL iBT preparation focuses on testspecific\ntechniques to support students\npursuing international study and\nprofessional opportunities.",
  icon: Book,
  path: "/CoursesPage#toefl"
}, {
  id: 3,
  title: "General English (Beginner to Advance)",
  description: "We offer General English programmes from beginner to advanced levels, designed to build strong foundations in speaking, listening, reading, and writing.",
  icon: Globe,
  path: "/CoursesPage#general-english"
}, {
  id: 4,
  title: "General German Language (Beginner to Advance)",
  description: "A structured programme designed to\ndevelop confident, real-world German\ncommunication from beginner to\nadvanced levels.",
  icon: Languages,
  path: "/CoursesPage#german"
}];
export default function CourseOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="course-overview" className="dark bg-background text-foreground py-24 px-6" ref={ref}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className={`font-display text-[42px] leading-[1.2] font-bold tracking-[-0.5px] mb-4 transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            Our Language Programs
          </h2>
          <p className={`text-lg text-muted-foreground max-w-2xl mx-auto transition-all duration-500 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            Choose from our expertly designed courses tailored for French-speaking students
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {courses.map((course, i) => {
          const Icon = course.icon;
          return <Card key={course.id} data-index={i} className={`group relative overflow-hidden bg-dark-section border border-border-strong/30 hover:border-primary/50 transition-all duration-300 hover:scale-[1.02] hover:shadow-strong ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100 + 200}ms`
          }}>
                <CardHeader className="pb-4">
                  <div className="w-16 h-16 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl text-foreground-dark">
                    {course.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed !text-[hsl(0,0%,100%)]">
                    {course.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-2">
                  <div className="w-full opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                    <Link to={course.path} className="w-full">
                      <Button className="w-full btn-primary">
                        Enroll Now
                      </Button>
                    </Link>
                  </div>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}